// base64ListRequest uses UTF-8 bytes before btoa so requests with umlauts and other non ASCII
// characters are encoded correctly.
export function base64ListRequest(request: unknown) {
  const json = JSON.stringify(request);
  const bytes = new TextEncoder().encode(json);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return { request: btoa(binary) };
}
